import { themeColors } from "../../config.js";
import { WebViewStyles } from "./style.js";
const WebView = ({ id, width, height, data, blur }) => {
  const isUrl = (str) => {
    let url;
    try {
      url = new URL(str);
    } catch (_) {
      return false;
    }
    return (
      url.protocol === "http:" ||
      url.protocol === "https:" ||
      url.protocol === "file:" ||
      url.protocol === "data:"
    );
  };

  const isHTML = (str) => {
    return /<\/?[a-z][\s\S]*>/i.test(str);
  };

  const isBase64 = (str) => {
    if (str === "" || str.trim() === "") {
      return false;
    }
    try {
      return btoa(atob(str)) === str;
    } catch (e) {
      return false;
    }
  };

  if (blur) {
    return (
      <div
        id={id}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: themeColors.transparentBlack,
          width,
          height,
          border: "2px dotted white",
        }}
      >
        <div
          style={{
            fontSize: 25,
            fontFamily: "roboto",
            color: themeColors.transparentWhite,
          }}
        >
          Resizing...
        </div>
      </div>
    );
  } else if (isUrl(data) || isBase64(data)) {
    return (
      <iframe
        id={id}
        title={"webview"}
        style={WebViewStyles.frame}
        width={width}
        height={height}
        src={data}
        data-cookieconsent="marketing"
      />
    );
  } else if (isHTML(data)) {
    return (
      <iframe
        id={id}
        title={"webview"}
        style={WebViewStyles.frame}
        width={width}
        height={height}
        srcDoc={data}
      />
    );
  }
  return <div style={{ ...WebViewStyles.frame, width, height }}>{data}</div>;
};

export default WebView;
